<div class="grid grid-cols-3 gap-2">
  <div class="flex flex-col col-span-2">
    <label [tailLabel]="l" i18n="@@link">Link</label>
    <input type="text" tailInput #l="input" [(ngModel)]="value.href" placeholder="https://..." i18n-placeholder="@@link_placeholder">
  </div>
  <div class="flex flex-col col-span-1">
    <label [tailLabel]="t" i18n="@@link_target">Target</label>
    <select tailInput #t="input" class="appearance-none" [(ngModel)]="value.target">
      <option *ngFor="let target of targets" [value]="target">
        {{getTargetLabel(target)}}
      </option>
    </select>
  </div>
</div>
